exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".filters .autocomplete {\n  width: 35%;\n}\n.disclaimer {\n  margin: 1rem 0;\n  text-align: center;\n}\n.printBody {\n  padding: 4rem;\n}\n", ""]);

